package com.trevorwiebe.timesheet.admin.reporting.presentation.components

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.trevorwiebe.timesheet.admin.reporting.domain.MissingStartEndBoundary
import com.trevorwiebe.timesheet.core.domain.Util

@Composable
fun MissingStartEndResultsHeader() {
    Surface(color = MaterialTheme.colorScheme.background) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 12.dp, vertical = 10.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Text(
                text = "Truck",
                modifier = Modifier.weight(0.8f),
                fontWeight = FontWeight.Bold,
                fontSize = 14.sp
            )
            Text(
                text = "End Day",
                modifier = Modifier.weight(1.1f),
                fontWeight = FontWeight.Bold,
                fontSize = 14.sp
            )
            Text(
                text = "Start Day",
                modifier = Modifier.weight(1.1f),
                fontWeight = FontWeight.Bold,
                fontSize = 14.sp
            )
            Text(
                text = "Missing",
                modifier = Modifier.weight(0.8f),
                fontWeight = FontWeight.Bold,
                fontSize = 14.sp,
                textAlign = TextAlign.End
            )
        }
    }
}

@Composable
fun MissingStartEndBoundaryRow(row: MissingStartEndBoundary, onClick: () -> Unit) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .clickable(onClick = onClick)
            .padding(horizontal = 12.dp, vertical = 10.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Text(
            text = row.unitNumber,
            modifier = Modifier.weight(0.8f),
            fontSize = 14.sp,
            maxLines = 1,
            overflow = TextOverflow.Ellipsis
        )
        Text(
            text = row.endDate?.let { Util.toFriendlyDate(it) } ?: "—",
            modifier = Modifier.weight(1.1f),
            fontSize = 14.sp,
            maxLines = 1,
            overflow = TextOverflow.Ellipsis
        )
        Text(
            text = row.startDate?.let { Util.toFriendlyDate(it) } ?: "—",
            modifier = Modifier.weight(1.1f),
            fontSize = 14.sp,
            maxLines = 1,
            overflow = TextOverflow.Ellipsis
        )
        Text(
            text = row.missingLabel(),
            modifier = Modifier.weight(0.8f),
            fontSize = 14.sp,
            color = MaterialTheme.colorScheme.error,
            textAlign = TextAlign.End
        )
    }
    HorizontalDivider()
}

fun MissingStartEndBoundary.missingLabel(): String = when {
    missingEnd && missingStart -> "Both"
    missingEnd -> "End"
    else -> "Start"
}
